// extracted by mini-css-extract-plugin
export default {"wrapper":"pagination_wrapper__1SyDW","btn":"pagination_btn__kQ1Ha","btnActive":"pagination_btnActive__W+hOK"};